import { sqItemRuntimeStore } from '@/core/core.stores';
import type { ItemYAxisExtremes } from '@/trendData/itemRuntime.store';

/**
 * Returns the computed y-axis extremes for an item, falling back to its parent's entry; children
 * render on their parent's axis (they previously received cloned copies of these fields via
 * CHILD_CLONED_PROPERTIES).
 */
export function getComputedYAxisExtremes(item: { id: string; isChildOf?: string }): ItemYAxisExtremes | undefined {
  const { yAxisExtremes } = sqItemRuntimeStore.getState();
  return yAxisExtremes[item.id] ?? (item.isChildOf ? yAxisExtremes[item.isChildOf] : undefined);
}

/**
 * Overlays the computed y-axis extremes onto an item so readers see the effective values. Items
 * without a computed entry are returned as-is (identity preserved), leaving their persisted
 * fields, user-set extremes or values rehydrated from a workstep, in effect.
 */
export function withEffectiveYAxisExtremes<T extends { id: string; isChildOf?: string }>(item: T): T {
  const computed = getComputedYAxisExtremes(item);
  return computed ? { ...item, ...computed } : item;
}
